export default "<div class=\"loading\">\r\n  <span></span>\r\n  <span></span>\r\n  <span></span>\r\n</div>\r\n";